import { useEffect, useState, useRef } from "react";
import { LoadPanel, TextBox, NumberBox, TextArea } from "devextreme-react";
import axios from "axios";
import { ColumnDropdown } from "../../components/Dropdownn";
import { Toster } from "../../components/Toster/Toster";
import { handleGetLocal } from "../../services/auth-service";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../components/Logout";
import "./AddEditConditionVerbiage.css";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name}
        reset={reset}
      />
    </>
  );
};

const AddEditConditionVerbiage = ({ mode, rowData, setPopupOpen, refresh, toastConfig, setToastConfig }) => {
  const navigate = useNavigate();
  const pathname = handleGetLocal("pathURL");
  const componentRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [courtDropdown, setCourtDropdown] = useState([]);
  console.log("rowData", rowData);

  const [fields, setFields] = useState({
    Court: { name: "", id: "" },
    ConditionNumber: "",
    SortOrder: 1,
    Condition: "",
    Violation: "",
    FirstPerson: "",
    ThirdPerson: "",
  });
  console.log("fields", fields);

  const [validation, setValidation] = useState({
    Court: "",
    ConditionNumber: "",
    Condition: "",
    Violation: "",
    FirstPerson: "",
    ThirdPerson: "",
  });

  const getCourts = () => {
    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/generic-parameter-lookup?parameter=Court`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: pathname,
        },
      })
      .then((res) => {
        const courts =
          res?.data?.data?.map((c) => ({
            name: c.value,
            id: String(c.id),
          })) || [];

        setCourtDropdown(courts);
        setLoading(false);
      })
      .catch((err) => handleError(err));
  };

  useEffect(() => {
    if (mode === "EDIT" && rowData) {
      setFields((prev) => ({
        ...prev,
        ConditionNumber: rowData?.sConditionNumber || "",
        SortOrder: rowData?.iSort || 1,
        Condition: rowData?.sCondition || "",
        Violation: rowData?.sViolation || "",
        FirstPerson: rowData?.sFirstPersonViolation || "",
        ThirdPerson: rowData?.sThirdPersonViolation || "",
      }));
    } else {
      setFields({
        Court: { name: "", id: "" },
        ConditionNumber: "",
        SortOrder: "",
        Condition: "",
        Violation: "",
        FirstPerson: "",
        ThirdPerson: "",
      });
    }

    setValidation({
      Court: "",
      ConditionNumber: "",
      Condition: "",
      Violation: "",
      FirstPerson: "",
      ThirdPerson: "",
    });
  }, [rowData, mode]);
  const validateFields = () => {
    let valid = true;

    const newValidation = {
      Court: "",
      ConditionNumber: "",
      Condition: "",
      Violation: "",
      FirstPerson: "",
      ThirdPerson: "",
    };

    if (!fields?.Court?.id) {
      newValidation.Court = "Please select Court";
      valid = false;
    }

    if (!fields?.ConditionNumber) {
      newValidation.ConditionNumber = "Please enter Condition Number";
      valid = false;
    }

    if (!fields?.Condition?.trim()) {
      newValidation.Condition = "Please enter Condition";
      valid = false;
    }

    if (!fields?.Violation?.trim()) {
      newValidation.Violation = "Please enter Violation";
      valid = false;
    }
    // if (!fields?.FirstPerson?.trim()) { newValidation.FirstPerson = "Please enter First Person"; valid = false; }
    // if (!fields?.ThirdPerson?.trim()) { newValidation.ThirdPerson = "Please enter Third Person"; valid = false; }

    setValidation(newValidation);
    return valid;
  };
  useEffect(() => {
    getCourts();
  }, []);
  useEffect(() => {
    if (mode === "EDIT" && rowData?.sCourtName && courtDropdown.length > 0) {
      const match = courtDropdown.find((c) => c.name.trim().toLowerCase() === rowData.sCourtName.trim().toLowerCase());

      if (match) {
        setFields((prev) => ({
          ...prev,
          Court: {
            name: match.name,
            id: match.id,
          },
        }));
      }
    }
  }, [mode, rowData?.sCourtName, courtDropdown]);

  const saveVerbiage = () => {
    if (!validateFields()) return;

    setLoading(true);

    const payload = {
      gVerbiageId: mode === "EDIT" ? rowData?.gVerbiageId : null,
      gEntityId: fields?.Court?.id,
      sConditionNumber: fields?.ConditionNumber,
      iSort: fields?.SortOrder,
      sCondition: fields?.Condition,
      sViolation: fields?.Violation,
      sFirstPersonViolation: fields?.FirstPerson,
      sThirdPersonViolation: fields?.ThirdPerson,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/document-wizard/save-verbiage`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: pathname,
        },
      })
      .then((res) => {
        setPopupOpen(false);
        setToastConfig((prev) => ({
          ...prev,
          isVisible: true,
          type: "success",
          message:
            mode === "EDIT" ? "Condition Verbiage updated successfully" : "Condition Verbiage added successfully",
        }));
        setTimeout(() => {
          setToastConfig({
            ...toastConfig,
            isVisible: false,
            message:
              mode === "EDIT" ? "Condition Verbiage updated successfully" : "Condition Verbiage added successfully",
            type: "success",
          });
        }, 1900);
        refresh();
        setLoading(false);
      })
      .catch((err) => handleError(err));
  };
  const handleError = (error) => {
    setLoading(false);

    if (!error?.response) {
      navigate("/error/500");
    } else if (error?.response?.status === 401) {
      logOut();
    } else {
      setToastConfig({
        isVisible: true,
        type: "error",
        message: "Failed to save Condition Verbiage",
      });
    }
  };
  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <div ref={componentRef} className="notes_edit_popup condition_verbiage_popup">
        <div className="RecivePaymentModel_header">
          <div style={{ width: "280px" }} className="RecivePaymentModel_header_name">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.41 5.41L14.58 0.58C14.21 0.21 13.7 0 13.17 0H2C0.9 0 0 0.9 0 2V14.01C0 15.11 0.89 16 1.99 16H18C19.1 16 20 15.1 20 14V6.83C20 6.3 19.79 5.79 19.41 5.41ZM13 1.5L18.5 7H14C13.45 7 13 6.55 13 6V1.5Z"
                fill="white"
              />
            </svg>

            <p style={{ marginLeft: "-10px" }}>{mode === "EDIT" ? "Edit" : "Add"} Conditions / Violations</p>

            <span
              style={{
                padding: "2px 9px",
                gap: "8px",
                width: "45px",
                height: "24px",
                background: "#FEF2F2",
                borderRadius: "4px",
              }}
            >
              <p
                style={{
                  color: "#DC2626",
                  fontFamily: "Readex Pro",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "10px",
                  lineHeight: "20px",
                  width: "21px",
                  height: "20px",
                }}
              >
                MB.3
              </p>
            </span>
          </div>

          <svg
            onClick={() => setPopupOpen(false)}
            style={{
              cursor: "pointer",
              marginTop: "17px",
              marginRight: "2%",
            }}
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="editTable_notes">
          <div className="editTable_notes_bottom">
            <div className="editTable_notes_bottom_dropdown" style={{ width: "55%" }}>
              <p className="go-to-label-filed">
                Court <em style={{ color: "red", fontSize: "15px" }}>*</em>
              </p>

              <DropDown dropDownData={courtDropdown} fieldNmae="Court" fields={fields} setfields={setFields} />

              {validation.Court && <p style={{ color: "red" }}>{validation.Court}</p>}
            </div>
          </div>
          <div style={{ width: "22%", marginLeft: "10px" }}>
            <p className="go-to-label-filed">
              Condition Number <em style={{ color: "red", fontSize: "15px" }}>*</em>
            </p>

            <TextBox
              value={fields.ConditionNumber}
              onValueChange={(e) => {
                setFields({ ...fields, ConditionNumber: e });
                setValidation({ ...validation, ConditionNumber: "" });
              }}
            />

            {validation.ConditionNumber && <p style={{ color: "red" }}>{validation.ConditionNumber}</p>}
          </div>
          <div style={{ width: "20%", marginLeft: "10px" }}>
            <p className="go-to-label-filed">Sort Order</p>

            <TextBox value={fields.SortOrder} onValueChange={(e) => setFields({ ...fields, SortOrder: e })} />
          </div>
          <div className="condition_verbiage_textareas">
            <div className="condition_block">
              <p className="go-to-label-filed">
                Condition <em style={{ color: "red", fontSize: "15px" }}>*</em>
              </p>
              <TextArea
                value={fields.Condition}
                minHeight={70}
                autoResizeEnabled={true}
                onValueChange={(e) => {
                  setFields({ ...fields, Condition: e });
                  setValidation({ ...validation, Condition: "" });
                }}
              />

              {validation.Condition && <p style={{ color: "red" }}>{validation.Condition}</p>}
            </div>

            <div className="condition_block">
              <p className="go-to-label-filed">
                Violation <em style={{ color: "red", fontSize: "15px" }}>*</em>
              </p>
              <TextArea
                value={fields.Violation}
                minHeight={70}
                autoResizeEnabled={true}
                onValueChange={(e) => {
                  setFields({ ...fields, Violation: e });
                  setValidation({ ...validation, Violation: "" });
                }}
              />

              {validation.Violation && <p style={{ color: "red" }}>{validation.Violation}</p>}
            </div>

            <div className="condition_block">
              <p className="go-to-label-filed">First Person</p>
              <TextArea
                value={fields.FirstPerson}
                minHeight={70}
                autoResizeEnabled={true}
                onValueChange={(e) => setFields({ ...fields, FirstPerson: e })}
              />
            </div>

            <div className="condition_block">
              <p className="go-to-label-filed">Third Person</p>
              <TextArea
                value={fields.ThirdPerson}
                minHeight={70}
                autoResizeEnabled={true}
                onValueChange={(e) => setFields({ ...fields, ThirdPerson: e })}
              />
            </div>
          </div>
          <div className="popup_buttons">
            <button className="btn primary_btn" onClick={() => setPopupOpen(false)}>
              Cancel
            </button>

            <button className="btn primary_btn" onClick={saveVerbiage}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddEditConditionVerbiage;
